import api from '../config/api'
import {
  post
} from "../config/https.js";
import EventBus from "@config/bus";
import store from '../store';
import IOS from "../components/ios";
import _ from "lodash";

/**
*
* @param {string} value 
* @return {string}
*/
export const getValueStatus = value => {
  if (!value) {
    value = ''
  }
  if (typeof value !== 'string') {
    value = value + ''
  }
  if (value.includes('-') && value != '-0.00') {
    return '1'
  } else {
    if (value == '0.00' || value == '0' || value == '-0.00' || value == '0.0000') {
      return '2'
    } else if (!value) {
      return '4'
    } else {
      return '3'
    }
  }
}
export const WATERMARK = (name, source, productId, subProductId, pubProductId) => {
  let waterMark = {
    pathName: name,
    source,
    productId,
    subProductId,
    pubProductId
  }
  let u = navigator.userAgent;
  if (u.match(/Mac OS X/i) == 'Mac OS X') {
    window.webkit.messageHandlers.getCurrentPage.postMessage(waterMark);
  } else {
    window.android.getCurrentPage(JSON.stringify(waterMark));
  }
}
export const getCurrentRedisData = (company) => {
  switch (company) {
    case '1':
      return '3'
      break;
    case '2':
      return '2'
      break;
    case '3':
      return '4'
      break;
    case '4':
      return '5'
      break;
    case '5':
      return '6'
      break;
  }
}
export const savePageParams = (obj, header) => {
  post(api.H5LogDetail, { optContent: JSON.stringify(obj) }, header).then((res) => {
  })
}

export const addScreenRotateListen = () => {
  const mql = window.matchMedia('(orientation: portrait)')
  function onMatchMeidaChange(mql) {
    if (mql.matches) {
      // 竖屏
      console.log('竖屏')
      EventBus.$emit('screenRotated', 'portrait')
    } else {
      // 横屏
      console.log('横屏')
      EventBus.$emit('screenRotated', 'landscape')
    }
  }
  onMatchMeidaChange(mql)
  mql.addListener(onMatchMeidaChange)
}

export const DevicePortraited = () => {
  const mql = window.matchMedia('(orientation: portrait)')
  if (mql.matches) {
    // console.log('DevicePortraited 竖屏')
    return true
  } else {
    // console.log('DevicePortraited 横屏')
    return false
  }

}

/**
 * @description 缓慢滚动
 * @param {*} stepNum 每次滚动的距离(正值: 向下; 负值: 向上)
 * @param {*} target 滚动到的位置
 */
export const goTop = (stepNum, target)=>{
  let scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  let scroll = window.requestAnimationFrame(()=>{
    let sum = (scrollTop += stepNum);
    let isBoundary = stepNum > 0 ? sum >= target : sum <= target;
    if (isBoundary) {
      window.cancelAnimationFrame(scroll)
      sum = target;
    }
    document.documentElement.scrollTop = sum;
    document.body.scrollTop = sum;
    if (!isBoundary) goTop(stepNum, target)
  })
}

export const isNotEmpty = (str) =>{
  let type = Object.prototype.toString.call(str),res=true
  switch(type){
    case '[object String]':
    case '[object Boolean]':
    case '[object Undefined]':
    case '[object Null]':
      res = !!str;
      break;
    case '[object Object]':
      res =  Object.keys(str).length>0;
      break;
    case '[object Array]':
      res =  str.length>0;
      break;
    default:
  }
  return res
}
/**
 * 函数防抖 (只执行最后一次点击)
 * @param fn
 * @param delay
 * @returns {Function}
 * @constructor
 */
 export const Debounce = (fn, t) => {
  let delay = t || 500;
  let timer;
  console.log(fn)
  console.log(typeof fn)
  return function () {
      let args = arguments;
      if(timer){
          clearTimeout(timer);
      }
      timer = setTimeout(() => {
          timer = null;
          fn.apply(this, args);
      }, delay);
  }
};


/**
* 函数节流
* @param fn
* @param interval
* @returns {Function}
* @constructor
*/
export const Throttle = (fn, t) => {
  let last;
  let timer;
  let interval = t || 500;
  return function () {
      let args = arguments;
      let now = +new Date();
      if (last && now - last < interval) {
          clearTimeout(timer);
          timer = setTimeout(() => {
              last = now;
              fn.apply(this, args);
          }, interval);
      } else {
          last = now;
          fn.apply(this, args);
      }
  }
};

export const isNumber = (val) =>{
  if (parseFloat(val).toString() == "NaN") {
    return false;
  } else {
    return true
  }
}

/**
 * @description 数据埋点--推送给原生
 * @param {*} productId 产品id 非必填
 * @param {*} pageSource 10-APP公募首页、20-基本、30-工具、40-公募榜、50-基金筛单、60-货币基金、70-新发基金、80-省心定投、90-稳健投资、100-追求收益 110-风向标 120-主题选基金 130-指数选基 140-股票选基
 */
export const pushPage = (productId, pageSource) =>{
  let params = {
      requestType: "save_buried_point_data_to_native",
      requestData: {
          productId: String(productId),
          pageSource: String(pageSource),
      }
  }

  if (store.state.getHeadInfo.company == 1) {
      if (IOS.ios()) {
          window.webkit.messageHandlers.requestEventData.postMessage(params);
      } else {
          window.android.requestEventData(JSON.stringify(params));
      }
  }
}
export const appRouteArr=['/myChoice','/basicDiskIndex','/toolCaseIndex','/publicList','/screening',
'/moneyFundIndex','/newFundIndex','/timeInvestIndex','/manageMoney','/pursueIncome','/windIndicator','/themeSelectFund','/exponentialSelectFund','/stockSearchFund','/shoppingCartModule']
export const appRouteObj = [
  {
    source: '220',
    name: '自选',
    url: '/myChoice'
  },
  {
    source: '20',
    name: '基本盘',
    url: '/basicDiskIndex'
  },
  {
    source: '30',
    name: '工具箱',
    url: '/toolCaseIndex'
  },
  {
    source: '40',
    name: '公募榜单',
    url: '/publicList'
  },
  {
    source: '50',
    name: '基金筛选',
    url: '/screening'
  },
  {
    source: '60',
    name: '货币基金',
    url: '/moneyFundIndex'
  },
  {
    source: '70',
    name: '新发基金',
    url: '/newFundIndex'
  },
  {
    source: '80',
    name: '省心定投',
    url: '/timeInvestIndex'
  },
  {
    source: '90',
    name: '稳健投资',
    url: '/manageMoney'
  },
  {
    source: '100',
    name: '追求收益',
    url: '/pursueIncome'
  },
  {
    source: '110',
    name: '风向标',
    url: '/windIndicator'
  },
  {
    source: '120',
    name: '主题选基',
    url: '/themeSelectFund'
  },
  {
    source: '130',
    name: '指数选基',
    url: '/exponentialSelectFund'
  },
  {
    source: '140',
    name: '股票选基',
    url: '/stockSearchFund'
  }
];

/**
 * @description 文案字段拼接
 * @param {Array} list 替换的数组
 * @param {Array} list2 替换的数组(改色)
 * @param {String} str 模板文本
 * @param {String} icon 被替换的文本/符号
 * @param {String} icon2 被替换的文本/符号(改色)
 * @param {String} color 颜色
 */
export const replaceText = (str, list, list2, icon='{}', icon2='##', color='#000')=>{
  if(!str)return
  let strDeep =  _.cloneDeep(str)
  let listDeep =  _.cloneDeep(list)
  let list2Deep =  _.cloneDeep(list2)
  while (strDeep.indexOf(icon) !== -1 && listDeep?.length) {
      strDeep = strDeep.replace(icon, listDeep.shift());
  }
  while (strDeep.indexOf(icon2) !== -1 && list2Deep?.length) {
    strDeep = strDeep.replace(icon2, `<span style='color:${color}'>`+list2Deep.shift()+"</span>");
  }
  return strDeep
}
/**
 * 账户信息若刷新无参，调新方法取参
 */
export const isQueryInterfaceResult = (nativeLogin)=>{
  let {groupCommonId,orgCommonId,company,userType,shlxLoginPersonType = ''} = nativeLogin
  let param = {
    groupCommonId,
    orgCommonId,
    companyId:company,
    loginPersonType:shlxLoginPersonType,
    userType
  }
  post(api.getPersonalCenterInfo,param).then((res) => {
    if(res.code === 10000){
      let obj = {
        ...nativeLogin,
        companyId:nativeLogin.company || '1',
        isOpenCompanyAccount:res.data.isOpenCompanyAccount
      }
      store.commit("getPersonalAccount", obj);
      store.commit("changeOpenAccount", obj);
    }
  })
}
/**
 * @description 判断哪个版本号能够执行，主要用于原生新增了方法，必须在符合的版本内
 * @param {String} iosVersion ios版本号
 * @param {String} androidVersion 安卓版本号
 */
export const appLimitVersion=(iosVersion,androidVersion)=>{
  const versions = (store.state.deviceInfo?.appVersion || '0.0.0').split('.');
  if(store.state.getHeadInfo.company==1){
    if (IOS.ios()) {
      if(iosVersion!=''){
        const iosArr=iosVersion.split('.');
        if (versions[0] > iosArr[0]) {
          return true;
        } else if (versions[0] == iosArr[0] && versions[1] > iosArr[1]) {
          return true;
        } else if (versions[0] == iosArr[0] && versions[1] == iosArr[1] && versions[2] >= iosArr[2]) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      if(androidVersion!=''){
        const androidArr=androidVersion.split('.');
        if (versions[0] > androidArr[0]) {
          return true;
        } else if (versions[0] == androidArr[0] && versions[1] > androidArr[1]) {
          return true;
        } else if (versions[0] == androidArr[0] && versions[1] == androidArr[1] && versions[2] >= androidArr[2]) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
}

/**
 * @description 判断哪个版本号能够执行，主要用于原生新增了方法，必须在符合的版本内
 * @param {String} iosVersion ios版本号
 * @param {String} androidVersion 安卓版本号
 */
export const limitVersion=(iosVersion,androidVersion)=>{
  const versions = (store.state.deviceInfo?.appVersion || store.state.baseInfoFromNative.version || '0.0.0').split('.');
    if (IOS.ios()) {
      if(iosVersion!=''){
        const iosArr=iosVersion.split('.');
        if (versions[0] > iosArr[0]) {
          return true;
        } else if (versions[0] == iosArr[0] && versions[1] > iosArr[1]) {
          return true;
        } else if (versions[0] == iosArr[0] && versions[1] == iosArr[1] && versions[2] >= iosArr[2]) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      if(androidVersion!=''){
        const androidArr=androidVersion.split('.');
        if (versions[0] > androidArr[0]) {
          return true;
        } else if (versions[0] == androidArr[0] && versions[1] > androidArr[1]) {
          return true;
        } else if (versions[0] == androidArr[0] && versions[1] == androidArr[1] && versions[2] >= androidArr[2]) {
          return true;
        } else {
          return false;
        }
      }
    }
}

export const isNullOrUndefinedOrEmpty = (obj)=> {
  return obj === null || obj === undefined || (typeof obj === 'object' && Object.keys(obj).length === 0);
}